import { useEffect } from "react";
import ServicesContext from "./ServiceContext";
import AdminState from "./ContextStore/AdminState";
import SeoState from "./ContextStore/SeoState";
import ProjectState from "./ContextStore/ProjectState";
import ContactState from "./ContextStore/ContactState";
import AppointmentState from "./ContextStore/AppointmentState";
import CommentatorState from "./ContextStore/CommentatorState";
import VisitorState from "./ContextStore/VisitorState";
import CareerState from "./ContextStore/CareerState";
import NotificationState from "./ContextStore/NotificationState";
import PostJobState from "./ContextStore/PostJobState";
import DepartmentState from "./ContextStore/DepartmentState";
import TeamState from "./ContextStore/TeamState";
import BlogsState from "./ContextStore/BlogsState";
import AuthorState from "./ContextStore/AuthorState";
import ServiceState from "./ContextStore/ServiceState";
import PropertyTypeState from "./ContextStore/PropertyTypeState";
import RatingsState from "./ContextStore/RatingsState";
import ScreeningState from "./ContextStore/ScreeningState";
import FollowClientState from "./ContextStore/FollowClientState";
import { jwtDecode } from "jwt-decode";

const ServiceProvider = ({ children }) => {
  let getToken = localStorage.getItem("token");
  let decoded = "";
  if (getToken?.length > 10) {
    decoded = jwtDecode(getToken)?._doc;
  }

  useEffect(() => {}, [decoded]);

  return (
    <ServicesContext.Provider
      value={{
        AdminState: AdminState,
        SeoState: SeoState,
        ProjectState: ProjectState,
        PropertyTypeState: PropertyTypeState,
        ContactState: ContactState,
        AppointmentState: AppointmentState,
        CommentatorState: CommentatorState,
        VisitorState: VisitorState,
        CareerState: CareerState,
        NotificationState: NotificationState,
        PostJobState: PostJobState,
        DepartmentState: DepartmentState,
        TeamState: TeamState,
        BlogsState: BlogsState,
        ServiceState: ServiceState,
        AuthorState: AuthorState,
        RatingsState: RatingsState,
        ScreeningState: ScreeningState,
        FollowClientState: FollowClientState,

        // Misc
        decoded,
      }}
    >
      {children}
    </ServicesContext.Provider>
  );
};

export default ServiceProvider;
